(function () {

  'use strict';

  function pxAddQueuesToGroup(
    GroupListService, PrintQueueListPaging, $timeout, PrintQueueListService, PrintQueuePropertiesModel,
    toastr, $filter, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        groupQueues: '=groupQueues',
        group: '=group',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/groupProperties/addQueuesToGroup/addQueuesToGroup.template.html',
      link: function (scope) {

        scope.focus = false;
        scope.paginationObject = new PrintQueueListPaging();
        let scrollEnd = null;
        let containerHeight = null;
        scope.loadingPage = true;
        scope.searchString = '';

        scope.refreshPrintQueueListPaging = new PrintQueueListPaging();
        let scrollEndAssociatedQueues = null;
        let containerHeightAssociatedQueues = null;
        scope.loadingPageAssociatedQueues = true;
        scope.searchStringAssociatedQueues = '';
        scope.noDataMessage = 'NoSearchResultQueue';

        scope.associatedPrintQueueListPaging = new PrintQueueListPaging();

        scope.newGroupQueues = [];

        scope.working = false;
        scope.showDefaultQueueWarning = false;

        scope.inCoolDown = false;

        (function () {
          getFirstPage();
          getFirstPage_associatedQueues();
          getFirstPage_associatedQueues_totalElements();
        })();

        $timeout(function () {
          scope.focus = true;
        }, 300);

        /************************
        * PAGINATION FOR QUEUES *
        ************************/
        function getFirstPage() {
          scope.paginationObject.pagingCriteria.page = 0;
          scope.paginationObject.pagingCriteria.pageSize = 20;
          scope.paginationObject.pagingCriteria.groupFilterMode = 'NOT_ATTACHED_TO_GROUPS';
          scope.paginationObject.pagingCriteria.groups = [scope.group.info._links.self.href];
          // scope.paginationObject.pagingCriteria.networks = scope.me.permissions.TENANT_ADMIN && !(scope.me.isSystemObserver() && scope.me.isSiteManager()) ? null : scope.me.networks;
          // scope.paginationObject.pagingCriteria.excludeQueues = excludeQueues()

          scope.list = [];
          scope.loadingPage = true;
          PrintQueueListService.getPrintQueueListPaged(scope.paginationObject)
            .then(function (response) {
              window.scrollTo(0, 0);
              scope.loadingPage = false;
              scope.totalPages = response.page.totalPages;
              scope.totalElements = response.page.totalElements;
              if (response.list) {
                scope.list = response.list;
              }
            })
            .catch(function () {
              scope.loadingPage = false;
            });
        }

        function excludeQueues() {
          const excludeQueues = [];
          for (let i = 0; i < scope.groupQueues.length; i++) {
            excludeQueues.push(scope.groupQueues[i].info._links.self.href);
          }
          return excludeQueues;
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          getFirstPage();
        };

        function getNextPage() {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            PrintQueueListService.getPrintQueueListPaged(scope.paginationObject)
              .then(function (response) {
                if (response.list) {
                  scope.list = scope.list.concat(response.list);
                }
                scope.loadingPage = false;
              })
              .catch(function () {
                scope.loadingPage = false;
              });
          }
        }

        angular.element('#QueueList').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              getNextPage();
            }
          }
        });

        /******************************
        * PAGINATION FOR GROUP QUEUES *
        ******************************/
        function getFirstPage_associatedQueues() {

          // scope.groupQueues = [];
          const url = scope.group.info._links['px:queues'].href;
          scope.refreshPrintQueueListPaging.pagingCriteria.page = 0;
          scope.refreshPrintQueueListPaging.pagingCriteria.pageSize = 20;
          scope.refreshPrintQueueListPaging.pagingCriteria.direction = 'ASC';
          scope.refreshPrintQueueListPaging.pagingCriteria.sort = 'QUEUE_NAME';
          scope.refreshPrintQueueListPaging.pagingCriteria.groups = [scope.group.info._links.self.href];
          scope.refreshPrintQueueListPaging.pagingCriteria.groupFilterMode = 'ATTACHED_TO_GROUPS';
          // scope.refreshPrintQueueListPaging.pagingCriteria.networks = scope.me.permissions.TENANT_ADMIN && !(scope.me.isSystemObserver() && scope.me.isSiteManager()) ? null : scope.me.networks;

          scope.loadingPageAssociatedQueues = true;
          GroupListService.getGroupPrintQueues(url, scope.refreshPrintQueueListPaging.pagingCriteria)
            .then(function (response) {
              angular.element('#GroupQueueList').scrollTop(0);
              scope.groupQueues = response.list;
              scope.groupQueuesPage = response.page;
              scope.totalPagesAssociatedQueues = response.page.totalPages;
              scope.working = false;
              scope.loadingPageAssociatedQueues = false;
              checkQueueuGroupsState();
            })
            .catch(function () {
              scope.loadingPageAssociatedQueues = false;
            });
        }

        scope.textSearchAssociatedQueues = function () {
          scope.refreshPrintQueueListPaging.pagingCriteria.match = scope.searchStringAssociatedQueues;
          scope.loadingPageAssociatedQueues = true;
          getFirstPage_associatedQueues();
        };

        function getNextPage_associatedQueues() {
          const url = scope.group.info._links['px:queues'].href;
          if (!scope.loadingPageAssociatedQueues && scope.totalPagesAssociatedQueues > scope.refreshPrintQueueListPaging.pagingCriteria.page + 1) {
            scope.loadingPageAssociatedQueues = true;
            scope.refreshPrintQueueListPaging.pagingCriteria.page += 1;
            GroupListService.getGroupPrintQueues(url, scope.refreshPrintQueueListPaging.pagingCriteria)
              .then(function (response) {
                if (response.list) {
                  scope.groupQueues = scope.groupQueues.concat(response.list);
                }
                scope.loadingPageAssociatedQueues = false;
                checkQueueuGroupsState();
              })
              .catch(function () {
                scope.loadingPageAssociatedQueues = false;
              });
          }
        }

        angular.element('#GroupQueueList').on('scroll', function (event) {
          scrollEndAssociatedQueues = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeightAssociatedQueues = event.currentTarget.scrollHeight;
          if (!scope.loadingPageAssociatedQueues && scope.totalPagesAssociatedQueues > scope.refreshPrintQueueListPaging.pagingCriteria.page + 1) {
            if (scrollEndAssociatedQueues > containerHeightAssociatedQueues) {
              getNextPage_associatedQueues();
            }
          }
        });

        /*************************
        * GETTING TOTAL ELEMENTS *
        *************************/
        function getFirstPage_associatedQueues_totalElements() {
          const url = scope.group.info._links['px:queues'].href;
          scope.associatedPrintQueueListPaging.pagingCriteria.page = 0;
          scope.associatedPrintQueueListPaging.pagingCriteria.pageSize = 1;
          scope.associatedPrintQueueListPaging.pagingCriteria.direction = 'ASC';
          scope.associatedPrintQueueListPaging.pagingCriteria.sort = 'QUEUE_NAME';
          scope.associatedPrintQueueListPaging.pagingCriteria.groups = [scope.group.info._links.self.href];
          scope.associatedPrintQueueListPaging.pagingCriteria.groupFilterMode = 'ATTACHED_TO_GROUPS';
          // scope.associatedPrintQueueListPaging.pagingCriteria.networks = scope.me.permissions.TENANT_ADMIN && !(scope.me.isSystemObserver() && scope.me.isSiteManager()) ? null : scope.me.networks;

          GroupListService.getGroupPrintQueues(url, scope.associatedPrintQueueListPaging.pagingCriteria)
            .then(function (response) {
              scope.totalElements_associatedPrintQueue = response.page.totalElements;
            })
            .catch(function () {
            });
        }

        /**********************
        * UPDATE GROUP QUEUES *
        **********************/
        function update_associatedQueues() {
          scope.newGroupQueues = [];
          scope.groupQueues = [];
          const url = scope.group.info._links['px:queues'].href;
          scope.associatedPrintQueueListPaging.pagingCriteria.page = 0;

          scope.loadingPageAssociatedQueues = true;
          GroupListService.getGroupPrintQueues(url, scope.refreshPrintQueueListPaging.pagingCriteria)
            .then(function (response) {
              scope.groupQueues = response.list;
              scope.groupQueuesPage = response.page;
              scope.totalPagesAssociatedQueues = response.page.totalPages;
              scope.working = false;
              scope.loadingPageAssociatedQueues = false;
              getFirstPage(); // TODO REMEMBER TO UPDATE ORIGINAL QUEUE LIST WHEN UPDATE HAS HAPPEND
              getFirstPage_associatedQueues_totalElements();
              checkQueueuGroupsState();
            })
            .catch(function () {
              scope.loadingPageAssociatedQueues = false;
            });
        }

        function checkQueueuGroupsState() {
          angular.forEach(scope.groupQueues, function (queue) {

            queue.groupSetting = {
              autoInstallGroup: false,
              defaultForGroup: false,
              group: false
            };

            const autoInstallGroupLink = queue.info._links['px:autoInstallGroup'];
            if (autoInstallGroupLink) {
              if (angular.isArray(autoInstallGroupLink)) {
                queue.groupSetting.autoInstallGroup = autoInstallGroupLink.some(function (link) {
                  return link.href === scope.group.info._links.self.href;
                });
              } else {
                if (autoInstallGroupLink.href === scope.group.info._links.self.href) {
                  queue.groupSetting.autoInstallGroup = true;
                }
              }
            }

            const defaultForGroupLink = queue.info._links['px:defaultForGroup'];
            if (defaultForGroupLink) {
              if (angular.isArray(defaultForGroupLink)) {
                queue.groupSetting.defaultForGroup = defaultForGroupLink.some(function (link) {
                  return link.href === scope.group.info._links.self.href;
                });
              } else {
                if (defaultForGroupLink.href === scope.group.info._links.self.href) {
                  queue.groupSetting.defaultForGroup = true;
                }
              }
            }

            const groupLink = queue.info._links['px:group'];
            if (groupLink) {
              if (angular.isArray(groupLink)) {
                queue.groupSetting.group = groupLink.some(function (link) {
                  return link.href === scope.group.info._links.self.href;
                });
              } else {
                if (groupLink.href === scope.group.info._links.self.href) {
                  queue.groupSetting.group = true;
                }
              }
            }

            queue.customProperties.id = setId(queue.info._links.self.href);
          });

          scope.groupQueuesCopy = angular.copy(scope.groupQueues);
        }

        function setId(queueLink) {
          const id = queueLink.split('/');
          return id[id.length - 1];
        }

        scope.checkForDefaultQueues = function (changedQueue) {

          angular.forEach(scope.groupQueues, function (queue) {
            if (queue.info._links.self.href !== changedQueue.info._links.self.href) {
              if (queue.groupSetting.defaultForGroup) {
                scope.showDefaultQueueWarning = queue.customProperties.id;
              }
              queue.groupSetting.defaultForGroup = false;
            }
          });

          angular.forEach(scope.newGroupQueues, function (queue) {
            if (queue.info._links.self.href !== changedQueue.info._links.self.href) {
              queue.groupSetting.defaultForGroup = false;
            }
          });

        };

        scope.removeFromQueueToGroup = function (event, queue) {
          event.stopPropagation();
          const thisQueue = angular.copy(queue);
          thisQueue.customProperties.id = setId(thisQueue.info._links.self.href);
          for (let i = 0; i < scope.newGroupQueues.length; i++) {
            if (scope.newGroupQueues[i].customProperties.id === thisQueue.customProperties.id) {
              scope.newGroupQueues.splice(i, 1);
              break;
            }
          }
        };

        scope.addQueueToGroup = function (event, queue) {
          event.stopPropagation();
          const thisQueue = angular.copy(queue);
          thisQueue.groupSetting = {
            autoInstallGroup: false,
            defaultForGroup: false,
            group: false
          };
          thisQueue.customProperties.id = setId(thisQueue.info._links.self.href);
          let onTheList = false;
          for (let i = 0; i < scope.newGroupQueues.length; i++) {
            if (scope.newGroupQueues[i].customProperties.id === thisQueue.customProperties.id) {
              onTheList = true;
              break;
            }
          }

          if (!onTheList) {
            scope.newGroupQueues.push(thisQueue);
          }
        };

        scope.saveSettings = function () {
          scope.inCoolDown = true;
          scope.showDefaultQueueWarning = false;
          createRequestQueue();
          $timeout(function () {
            scope.inCoolDown = false;
          }, 3000);
        };

        function createRequestQueue() {
          let requestJobQueue = [];

          for (let i = 0; i < scope.groupQueues.length; i++) {
            for (const key in scope.groupQueues[i].groupSetting) {
              if (scope.groupQueues[i].groupSetting[key] !== scope.groupQueuesCopy[i].groupSetting[key]) {
                const request = {
                  action: scope.groupQueues[i].groupSetting[key] ? 'add' : 'remove',
                  key,
                  queue: scope.groupQueues[i]
                };
                requestJobQueue.push(request);
              }
            }
          }

          for (let i = 0; i < scope.newGroupQueues.length; i++) {
            for (const key in scope.newGroupQueues[i].groupSetting) {
              if (scope.newGroupQueues[i].groupSetting[key]) {
                const request = {
                  action: 'add',
                  key,
                  queue: scope.newGroupQueues[i]
                };
                requestJobQueue.push(request);
              }
            }
          }

          if (requestJobQueue.length > 0) {
            requestJobQueue = arrangeJobQueue(requestJobQueue);
            executeRequestJobs(requestJobQueue);
          } else {
            toastr.error($filter('translate')('NoChangesMade'));
          }
        }

        function arrangeJobQueue(requestJobQueue) {
          let priotizedJob = null;
          for (let i = 0; i < requestJobQueue.length; i++) {
            if (requestJobQueue[i].key === 'defaultForGroup' && requestJobQueue[i].action === 'remove') {
              priotizedJob = requestJobQueue[i];
              requestJobQueue.splice(i, 1);
              break;
            }
          }

          if (priotizedJob) {
            requestJobQueue.unshift(priotizedJob);
          }

          return requestJobQueue;
        }

        function executeRequestJobs(requestJobQueue) {
          scope.working = true;
          switch (requestJobQueue[0].key) {
            case 'group':
              handleGroupJob(requestJobQueue[0], requestJobQueue);
              break;
            case 'defaultForGroup':
              handleDefaultForGroupJob(requestJobQueue[0], requestJobQueue);
              break;
            case 'autoInstallGroup':
              handleAutoInstallJob(requestJobQueue[0], requestJobQueue);
              break;
          }
        }

        function evalutateProgress(requestJobQueue) {
          const containerWidth = angular.element('.screen-progress-container').innerWidth();
          let progress = 0;
          if (requestJobQueue.length > 0) {
            progress = containerWidth / (requestJobQueue.length + 1);
          } else {
            progress = containerWidth;
          }
          angular.element('.screen-progress-bar').css({ width: progress });
        }

        function handleGroupJob(requestJob, requestJobQueue) {
          const queue = new PrintQueuePropertiesModel(requestJob.queue.info);
          if (requestJob.action === 'add') {

            queue.setExclusiveAccessGroup(scope.group).then(function (response) {
              requestJobQueue.shift();
              evalutateProgress(requestJobQueue);
              if (requestJobQueue.length > 0) {
                executeRequestJobs(requestJobQueue);
              } else {
                update_associatedQueues();
                toastr.success($filter('translate')('ChangesSaved'));
                $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
              }

            }).catch(function () {
              update_associatedQueues();
              toastr.error($filter('translate')('ERROR'));
              $rootScope.$broadcast('UPDATE_GROUP_QUEUES');

            });

          } else {

            queue.deleteExclusiveAccessGroup(scope.group).then(function (response) {
              requestJobQueue.shift();
              evalutateProgress(requestJobQueue);
              if (requestJobQueue.length > 0) {
                executeRequestJobs(requestJobQueue);
              } else {
                update_associatedQueues();
                toastr.success($filter('translate')('ChangesSaved'));
                $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
              }
            }).catch(function () {
              update_associatedQueues();
              toastr.error($filter('translate')('ERROR'));
              $rootScope.$broadcast('UPDATE_GROUP_QUEUES');

            });

          }
        }

        function handleDefaultForGroupJob(requestJob, requestJobQueue) {
          const queue = new PrintQueuePropertiesModel(requestJob.queue.info);
          if (requestJob.action === 'add') {

            queue.setDefaultQueueGroup(scope.group).then(function (response) {
              requestJobQueue.shift();
              evalutateProgress(requestJobQueue);
              if (requestJobQueue.length > 0) {
                executeRequestJobs(requestJobQueue);
              } else {
                update_associatedQueues();
                toastr.success($filter('translate')('ChangesSaved'));
                $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
              }

            }).catch(function () {
              update_associatedQueues();
              toastr.error($filter('translate')('ERROR'));
              $rootScope.$broadcast('UPDATE_GROUP_QUEUES');

            });

          } else {

            queue.deleteDefaultForGroup(scope.group).then(function (response) {
              requestJobQueue.shift();
              evalutateProgress(requestJobQueue);
              if (requestJobQueue.length > 0) {
                executeRequestJobs(requestJobQueue);
              } else {
                update_associatedQueues();
                toastr.success($filter('translate')('ChangesSaved'));
                $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
              }

            }).catch(function () {
              update_associatedQueues();
              toastr.error($filter('translate')('ERROR'));
              $rootScope.$broadcast('UPDATE_GROUP_QUEUES');

            });

          }
        }

        function handleAutoInstallJob(requestJob, requestJobQueue) {
          const queue = new PrintQueuePropertiesModel(requestJob.queue.info);
          if (requestJob.action === 'add') {

            queue.setAutoInstallGroup(scope.group).then(function (response) {
              requestJobQueue.shift();
              evalutateProgress(requestJobQueue);
              if (requestJobQueue.length > 0) {
                executeRequestJobs(requestJobQueue);
              } else {
                update_associatedQueues();
                toastr.success($filter('translate')('ChangesSaved'));
                $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
              }

            }).catch(function () {
              update_associatedQueues();
              toastr.error($filter('translate')('ERROR'));
              $rootScope.$broadcast('UPDATE_GROUP_QUEUES');

            });

          } else {

            queue.deleteAutoInstallGroup(scope.group).then(function (response) {
              requestJobQueue.shift();
              evalutateProgress(requestJobQueue);
              if (requestJobQueue.length > 0) {
                executeRequestJobs(requestJobQueue);
              } else {
                update_associatedQueues();
                toastr.success($filter('translate')('ChangesSaved'));
                $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
              }

            }).catch(function () {
              update_associatedQueues();
              toastr.error($filter('translate')('ERROR'));
              $rootScope.$broadcast('UPDATE_GROUP_QUEUES');
            });
          }
        }

        scope.$on('$destroy', function () {
          angular.element('#QueueList').off('scroll');
          angular.element('#GroupQueueList').off('scroll');
        });

      }
    };
  }

  pxAddQueuesToGroup.$inject = [
    'GroupListService', 'PrintQueueListPaging', '$timeout', 'PrintQueueListService', 'PrintQueuePropertiesModel',
    'toastr', '$filter', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxAddQueuesToGroup', pxAddQueuesToGroup);

})();
